import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Pricing from "../pages/pricing/page";
import About from "../pages/about/page";
import Area from "../pages/area/page";
import Book from "../pages/book/page";
import Contact from "../pages/contact/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "services", element: <Services /> },
      { path: "pricing", element: <Pricing /> },
      { path: "about", element: <About /> },
      { path: "area", element: <Area /> },
      { path: "book", element: <Book /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;